import * as types from "../constants";
const initialState = {
  list: [],
  selectItem: {}
}

export default function reducer(state = initialState, actions){
  const { type, payload } = actions;
  switch(type){
    case types.GET_POTLIST:
      return{
        ...state,
        list: payload
      }
    case types.SELECT_PSETTINGS_ITEM:
    case types.ADD_NEW_CATEGORY:
    case types.SAVE_POT_CATEGORY:
    case types.SAVE_POT_DESCRIPTION:
    case types.CREATE_NEW_POT:
      return {
        ...state,
        selectItem: payload
      }
    default:
      return {
        ...state
      }
  }
}
